import { render, staticRenderFns } from "./ExpandQuestion.vue?vue&type=template&id=603d9b7a&"
import script from "./ExpandQuestion.vue?vue&type=script&lang=js&"
export * from "./ExpandQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ExpandQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports